import { render } from "./CourtAttendanceDialog.vue?vue&type=template&id=39efd8ce&ts=true"
import script from "./CourtAttendanceDialog.vue?vue&type=script&lang=ts"
export * from "./CourtAttendanceDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__